module.exports = __webpack_public_path__ + "static/DSC_9394-8c5af80a1397e488c5118a6d9f6065c3.jpg";